import { useParams } from 'react-router-dom';
import { useProjectDetailQuery } from 'src/services/queries/useProjectDetailQuery';

export default function useCurrentProject(id?: string) {
  const { projectId } = useParams<{ projectId: string }>();

  return useProjectDetailQuery(id || projectId);
}
